import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUsmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.609 9h9.39c0-.813-.107-1.6-.31-2.349H8.61V9Zm0-4.696h8.07a9.05 9.05 0 0 0-2.077-2.348H8.61v2.348ZM9 18a8.961 8.961 0 0 0 5.602-1.957H3.398A8.961 8.961 0 0 0 9 18Zm-7.679-4.305h15.358a8.946 8.946 0 0 0 1.011-2.347H.31a8.946 8.946 0 0 0 1.011 2.347Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.169 1.405h.82l-.763.555.292.897-.763-.555-.763.555.252-.775a9.049 9.049 0 0 0-1.746 1.945h.263l-.486.353a8.984 8.984 0 0 0-.217.385l.231.713-.432-.314c-.108.228-.206.46-.295.699l.256.786h.943l-.763.554.291.897-.762-.554-.457.332C.024 8.245 0 8.62 0 9h9V0a8.957 8.957 0 0 0-4.831 1.405ZM4.518 8.1l-.763-.554-.763.554.291-.897-.763-.554h.943l.292-.897.291.897h.943l-.763.554.292.897Zm-.292-3.519.292.897-.763-.554-.763.554.291-.897-.763-.554h.943l.292-.897.291.897h.943l-.763.554ZM7.746 8.1l-.763-.554-.763.554.292-.897-.763-.554h.943l.291-.897.291.897h.943l-.763.554.292.897Zm-.292-3.519.292.897-.763-.554-.763.554.292-.897-.763-.554h.943l.291-.897.291.897h.943l-.763.554Zm0-2.621.292.897-.763-.555-.763.555.292-.897-.763-.555h.943L6.983.51l.291.896h.943l-.763.555Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgIconUsmin);
export { ForwardRef as ReactComponent };
